import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import classnames from 'classnames';

const Checkbox = props => (
  <FormGroup row check className={classnames(props.classNameContainer, 'form-group-row')}>
    {!props.inline ? (
      <Label for={props.id} className="form-group-row__label">
        {props.required ? (
          <span>
            {props.label} <span className="text-orange">*</span>
          </span>
        ) : (
          props.label
        )}
      </Label>
    ) : null}
    <Col className="form-group-row__col">
      <Label className="custom-control custom-checkbox">
        <Input
          checked={props.checked}
          className={classnames(props.className, 'form-group-row__input custom-control-input')}
          disabled={props.disabled}
          id={props.id}
          name={props.name}
          type="checkbox"
          onChange={props.onChange}
        />
        {props.inline ? (
          <span className="custom-control-label">
            {props.required ? (
              <span>
                {props.label} <span className="text-orange">*</span>
              </span>
            ) : (
              props.label
            )}
          </span>
        ) : null}
      </Label>
    </Col>
  </FormGroup>
);

Checkbox.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  classNameContainer: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  inline: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
};

Checkbox.defaultProps = {
  inline: false,
};

export default Checkbox;
